import React from "react";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronCircleDown,
  faCheck,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
// import styles from "../../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import LeaseListingTable from "./LeaseListingTable";
import ProspectListingTable from "../../createLease/leaseList/ProspectListingTable";
class LeaseListing extends React.Component {
  state = {
    showProspect: false,
    redirect: false,
    brands: [],
    assets: [],
    statusCount: {},
    selectedBrand: this.props.match.params.brand ?? 0,
    selectedAsset: "",
    randomNum: "",
    selectedStatus: Number(this.props.match.params.status),
    state: this.props.match.params.state ?? 0,
  };

  constructor(props) {
    super(props);
    console.log(this.props.match.params.status);
  }

  componentDidMount() {
    //alert(this.props.match.params.state + " ok ");

    this.loadBrands();
    this.loadAssets();

    // fetch(`${apiUrl.apiUrl.url}/lease-view/get-status-count?brand=` + this.state.selectedBrand)
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       statusCount: data,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    this.loadLeaseCountStatuswise();
  }

  loadLeaseCountStatuswise(brand, asset) {
    // this.setState({});
    var brandId =
      typeof brand != "undefined" ? brand : this.state.selectedBrand;
    var assetId =
      typeof asset != "undefined" ? asset : this.state.selectedAsset;
    var ths = this;

    axios
      .post(
        `${apiUrl.apiUrl.url}/lease-view/get-status-count?brand=` +
        brandId +
        `&stateId=${this.state.state}&asset=${assetId}`
      )
      .then(function (response) {
        console.log(response, "response");
        ths.setState({
          statusCount: response.data,
        });
      });

    this.setState({});
  }

  loadAssets = async () => {
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/asset/fetch-all-assets`
    );
    console.log(response);
    this.state.assets = response.data;
    this.setState({});
  };

  loadBrands = async () => {
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/brand/get-brands?page=1&per_page=100&delay=1`
    );
    this.state.brands = response.data.data;
    this.setState({});
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/cam-logic" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (

      <>
        <div className="absoluteItemForTopBar">
          <div className="d-flex align-items-center gap-3 p-0 m-0 unitFormContainerNew">
            <select
              onChange={(e) => {
                this.setState({
                  selectedAsset: e.target.value,
                  randomNum: Math.random(),
                });
                this.loadLeaseCountStatuswise(
                  this.state.selectedBrand,
                  e.target.value
                );
              }}
            >
              <option value="">Select Asset</option>
              {this.state.assets.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.asset_name}
                </option>
              ))}
            </select>
            <select
              value={this.state.selectedBrand}
              onChange={(e) => {
                this.setState({
                  selectedBrand: e.target.value,
                });

                this.setState({ randomNum: Math.random() });

                this.loadLeaseCountStatuswise(
                  e.target.value,
                  this.state.selectedAsset
                );
              }}
            >
              <option value="">Select Brand</option>
              {this.state.brands.map((x) => (
                <option key={x.brandId} value={x.brandId}>
                  {x.brandName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="unitFormContainerNew">
          {/* <div className="container">
              <div className="row">
                <div className="col-lg-4 offset-lg-2">
                  <div className="inputContainer">
                    <select
                      onChange={(e) => {
                        this.setState({
                          selectedAsset: e.target.value,
                          randomNum: Math.random(),
                        });
                        this.loadLeaseCountStatuswise(
                          this.state.selectedBrand,
                          e.target.value
                        );
                      }}
                    >
                      <option value="">Select Asset</option>
                      {this.state.assets.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.asset_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="inputContainer">
                    <select
                      value={this.state.selectedBrand}
                      onChange={(e) => {
                        this.setState({
                          selectedBrand: e.target.value,
                        });

                        this.setState({ randomNum: Math.random() });

                        this.loadLeaseCountStatuswise(
                          e.target.value,
                          this.state.selectedAsset
                        );
                      }}
                    >
                      <option value="">Select Brand</option>
                      {this.state.brands.map((x) => (
                        <option key={x.brandId} value={x.brandId}>
                          {x.brandName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div> */}
          <div className="cardsNewUiMain">
            <div
              className={
                this.state.selectedStatus === 5
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                this.setState({
                  selectedStatus: 5,
                  randomNum: Math.random(),
                  showProspect: true,
                  isDropped: false,
                });
              }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.58329 17.4998C13.9555 17.4998 17.5 13.9554 17.5 9.58317C17.5 5.21092 13.9555 1.6665 9.58329 1.6665C5.21104 1.6665 1.66663 5.21092 1.66663 9.58317C1.66663 13.9554 5.21104 17.4998 9.58329 17.4998Z" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.3333 18.3333L15.5 15.5" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>


              <h2>{this.state.statusCount.prospect ? this.state.statusCount.prospect : "0"}</h2>
              <h5>Prospect </h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 6
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 6,
                  randomNum: Math.random(),
                  showProspect: true,
                  isDropped: true,
                });
              }}
            >

              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99996 18.3332C14.6023 18.3332 18.3333 14.6022 18.3333 9.99984C18.3333 5.39746 14.6023 1.6665 9.99996 1.6665C5.39759 1.6665 1.66663 5.39746 1.66663 9.99984C1.66663 14.6022 5.39759 18.3332 9.99996 18.3332Z" stroke="#272D3B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.05835 8.9502L10 11.8835L12.9417 8.9502" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <h2>{this.state.statusCount.dropped ? this.state.statusCount.dropped : "0"}</h2>
              <h5>Dropped </h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 0
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 0,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.32003 17.1367L4.66052 16.4684H4.66052L4.32003 17.1367ZM2.86331 15.68L2.19506 16.0205H2.19506L2.86331 15.68ZM15.68 2.86331L16.0205 2.19506V2.19506L15.68 2.86331ZM17.1367 4.32003L16.4684 4.66052V4.66052L17.1367 4.32003ZM4.32003 2.86331L4.66052 3.53157H4.66052L4.32003 2.86331ZM2.86331 4.32003L3.53157 4.66052V4.66052L2.86331 4.32003ZM16.75 9.16667C16.75 9.58088 17.0858 9.91667 17.5 9.91667C17.9142 9.91667 18.25 9.58088 18.25 9.16667H16.75ZM9.16667 18.25C9.58088 18.25 9.91667 17.9142 9.91667 17.5C9.91667 17.0858 9.58088 16.75 9.16667 16.75V18.25ZM6.66667 5.91667C6.25245 5.91667 5.91667 6.25245 5.91667 6.66667C5.91667 7.08088 6.25245 7.41667 6.66667 7.41667V5.91667ZM13.3333 7.41667C13.7475 7.41667 14.0833 7.08088 14.0833 6.66667C14.0833 6.25245 13.7475 5.91667 13.3333 5.91667V7.41667ZM6.66667 9.25C6.25245 9.25 5.91667 9.58579 5.91667 10C5.91667 10.4142 6.25245 10.75 6.66667 10.75V9.25ZM13.3333 10.75C13.7475 10.75 14.0833 10.4142 14.0833 10C14.0833 9.58579 13.7475 9.25 13.3333 9.25V10.75ZM6.66667 12.5833C6.25245 12.5833 5.91667 12.9191 5.91667 13.3333C5.91667 13.7475 6.25245 14.0833 6.66667 14.0833V12.5833ZM10 14.0833C10.4142 14.0833 10.75 13.7475 10.75 13.3333C10.75 12.9191 10.4142 12.5833 10 12.5833V14.0833ZM11.8777 17.9138L12.5892 18.151V18.151L11.8777 17.9138ZM12.2633 16.7568L11.5518 16.5197V16.5197L12.2633 16.7568ZM12.6613 16.113L13.1916 16.6433L13.1916 16.6433L12.6613 16.113ZM16.5045 12.2698L15.9742 11.7394L15.9742 11.7394L16.5045 12.2698ZM18.5636 14.3288L19.0939 14.8592V14.8592L18.5636 14.3288ZM14.7204 18.172L14.19 17.6417V17.6417L14.7204 18.172ZM14.0765 18.57L14.3137 19.2815H14.3137L14.0765 18.57ZM12.9195 18.9556L13.1567 19.6672H13.1567L12.9195 18.9556ZM14.5093 18.3691L14.961 18.9678V18.9678L14.5093 18.3691ZM14.3471 18.4693L14.0136 17.7975L14.3471 18.4693ZM18.5636 12.2698L18.0332 12.8001L18.5636 12.2698ZM19.0596 12.8422L19.7316 12.5092V12.5092L19.0596 12.8422ZM19.0596 13.7564L19.7316 14.0894V14.0894L19.0596 13.7564ZM17.0769 11.7737L17.4099 12.4457H17.4099L17.0769 11.7737ZM17.9912 11.7737L17.6582 12.4457H17.6582L17.9912 11.7737ZM12.364 16.4862L13.0358 16.8198H13.0358L12.364 16.4862ZM12.4643 16.324L11.8655 15.8724L11.8655 15.8724L12.4643 16.324ZM11.6858 18.8355L12.3923 18.5836V18.5836L11.6858 18.8355ZM11.9978 19.1475L11.7459 19.8539L11.9978 19.1475ZM7.83333 3.25H12.1667V1.75H7.83333V3.25ZM3.25 12.1667V7.83333H1.75V12.1667H3.25ZM7.83333 16.75C6.88754 16.75 6.2233 16.7494 5.70508 16.7071C5.19562 16.6655 4.89369 16.5872 4.66052 16.4684L3.97954 17.8049C4.45941 18.0494 4.98071 18.1529 5.58293 18.2021C6.1764 18.2506 6.91229 18.25 7.83333 18.25V16.75ZM1.75 12.1667C1.75 13.0877 1.74942 13.8236 1.7979 14.4171C1.84711 15.0193 1.95055 15.5406 2.19506 16.0205L3.53157 15.3395C3.41276 15.1063 3.33455 14.8044 3.29292 14.2949C3.25058 13.7767 3.25 13.1125 3.25 12.1667H1.75ZM4.66052 16.4684C4.17444 16.2208 3.77924 15.8256 3.53157 15.3395L2.19506 16.0205C2.58654 16.7888 3.21121 17.4135 3.97954 17.8049L4.66052 16.4684ZM12.1667 3.25C13.1125 3.25 13.7767 3.25058 14.2949 3.29292C14.8044 3.33455 15.1063 3.41276 15.3395 3.53157L16.0205 2.19506C15.5406 1.95055 15.0193 1.84711 14.4171 1.7979C13.8236 1.74942 13.0877 1.75 12.1667 1.75V3.25ZM18.25 7.83333C18.25 6.91229 18.2506 6.1764 18.2021 5.58293C18.1529 4.98071 18.0494 4.45941 17.8049 3.97954L16.4684 4.66052C16.5872 4.89369 16.6655 5.19562 16.7071 5.70508C16.7494 6.2233 16.75 6.88754 16.75 7.83333H18.25ZM15.3395 3.53157C15.8256 3.77924 16.2208 4.17444 16.4684 4.66052L17.8049 3.97954C17.4135 3.21121 16.7888 2.58654 16.0205 2.19506L15.3395 3.53157ZM7.83333 1.75C6.91229 1.75 6.1764 1.74942 5.58293 1.7979C4.98071 1.84711 4.45941 1.95055 3.97954 2.19506L4.66052 3.53157C4.89369 3.41276 5.19562 3.33455 5.70508 3.29292C6.2233 3.25058 6.88754 3.25 7.83333 3.25V1.75ZM3.25 7.83333C3.25 6.88754 3.25058 6.2233 3.29292 5.70508C3.33455 5.19562 3.41276 4.89369 3.53157 4.66052L2.19506 3.97954C1.95055 4.45941 1.84711 4.98071 1.7979 5.58293C1.74942 6.1764 1.75 6.91229 1.75 7.83333H3.25ZM3.97954 2.19506C3.21121 2.58654 2.58654 3.21121 2.19506 3.97954L3.53157 4.66052C3.77924 4.17444 4.17444 3.77924 4.66052 3.53157L3.97954 2.19506ZM16.75 7.83333V9.16667H18.25V7.83333H16.75ZM7.83333 18.25H9.16667V16.75H7.83333V18.25ZM6.66667 7.41667H13.3333V5.91667H6.66667V7.41667ZM6.66667 10.75H13.3333V9.25H6.66667V10.75ZM6.66667 14.0833H10V12.5833H6.66667V14.0833ZM12.5892 18.151L12.9749 16.994L11.5518 16.5197L11.1662 17.6767L12.5892 18.151ZM13.1916 16.6433L17.0348 12.8001L15.9742 11.7394L12.131 15.5826L13.1916 16.6433ZM18.0332 13.7985L14.19 17.6417L15.2507 18.7024L19.0939 14.8592L18.0332 13.7985ZM13.8393 17.8585L12.6823 18.2441L13.1567 19.6672L14.3137 19.2815L13.8393 17.8585ZM14.19 17.6417C14.0733 17.7584 14.0636 17.7658 14.0576 17.7703L14.961 18.9678C15.0695 18.8859 15.1623 18.7908 15.2507 18.7024L14.19 17.6417ZM14.3137 19.2815C14.4323 19.242 14.5589 19.2015 14.6806 19.1411L14.0136 17.7975C14.0068 17.8009 13.9959 17.8063 13.8393 17.8585L14.3137 19.2815ZM14.0576 17.7703C14.0438 17.7807 14.0291 17.7899 14.0136 17.7975L14.6806 19.1411C14.7792 19.0921 14.8731 19.0341 14.961 18.9678L14.0576 17.7703ZM18.0332 12.8001C18.1796 12.9464 18.2671 13.0344 18.3293 13.104C18.3879 13.1696 18.3925 13.1852 18.3876 13.1752L19.7316 12.5092C19.5882 12.2197 19.3318 11.9773 19.0939 11.7394L18.0332 12.8001ZM19.0939 14.8592C19.3318 14.6213 19.5882 14.3789 19.7316 14.0894L18.3876 13.4234C18.3925 13.4134 18.3879 13.429 18.3293 13.4946C18.2671 13.5642 18.1796 13.6522 18.0332 13.7985L19.0939 14.8592ZM18.3876 13.1752C18.4264 13.2534 18.4264 13.3452 18.3876 13.4234L19.7316 14.0894C19.9783 13.5916 19.9783 13.007 19.7316 12.5092L18.3876 13.1752ZM17.0348 12.8001C17.1811 12.6538 17.2691 12.5662 17.3387 12.5041C17.4043 12.4454 17.4199 12.4408 17.4099 12.4457L16.7439 11.1017C16.4544 11.2452 16.212 11.5016 15.9742 11.7394L17.0348 12.8001ZM19.0939 11.7394C18.856 11.5016 18.6137 11.2452 18.3242 11.1017L17.6582 12.4457C17.6482 12.4408 17.6637 12.4454 17.7294 12.5041C17.799 12.5662 17.8869 12.6538 18.0332 12.8001L19.0939 11.7394ZM17.4099 12.4457C17.4881 12.407 17.5799 12.407 17.6582 12.4457L18.3242 11.1017C17.8263 10.855 17.2418 10.855 16.7439 11.1017L17.4099 12.4457ZM12.9749 16.994C13.027 16.8374 13.0324 16.8265 13.0358 16.8198L11.6923 16.1527C11.6318 16.2744 11.5914 16.4011 11.5518 16.5197L12.9749 16.994ZM12.131 15.5826C12.0426 15.671 11.9474 15.7639 11.8655 15.8724L13.063 16.7757C13.0675 16.7697 13.0749 16.76 13.1916 16.6433L12.131 15.5826ZM13.0358 16.8198C13.0435 16.8043 13.0526 16.7895 13.063 16.7757L11.8655 15.8724C11.7992 15.9602 11.7412 16.0541 11.6923 16.1527L13.0358 16.8198ZM11.1662 17.6767C11.0871 17.914 11.0106 18.1411 10.9664 18.329C10.9249 18.5058 10.8735 18.7905 10.9794 19.0874L12.3923 18.5836C12.417 18.6529 12.4171 18.7053 12.4165 18.7202C12.4161 18.7316 12.4153 18.7203 12.4266 18.6721C12.4514 18.5668 12.5006 18.4167 12.5892 18.151L11.1662 17.6767ZM12.6823 18.2441C12.4167 18.3327 12.2666 18.3819 12.1612 18.4067C12.113 18.418 12.1017 18.4172 12.1131 18.4168C12.1281 18.4162 12.1804 18.4164 12.2497 18.4411L11.7459 19.8539C12.0429 19.9598 12.3275 19.9085 12.5043 19.8669C12.6922 19.8228 12.9194 19.7463 13.1567 19.6672L12.6823 18.2441ZM10.9794 19.0874C11.1069 19.445 11.3883 19.7264 11.7459 19.8539L12.2497 18.4411C12.3162 18.4648 12.3685 18.5171 12.3923 18.5836L10.9794 19.0874Z" fill="#272D3B" />
              </svg>

              <h2>{this.state.statusCount.draft ? this.state.statusCount.draft : "0"}</h2>
              <h5>Draft</h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 1
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 1,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.7583 12.2498L9.0083 13.4998L12.3416 10.1665" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.33329 4.99984H11.6666C13.3333 4.99984 13.3333 4.1665 13.3333 3.33317C13.3333 1.6665 12.5 1.6665 11.6666 1.6665H8.33329C7.49996 1.6665 6.66663 1.6665 6.66663 3.33317C6.66663 4.99984 7.49996 4.99984 8.33329 4.99984Z" stroke="#272D3B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501" stroke="#272D3B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <h2>{this.state.statusCount.approval ? this.state.statusCount.approval : "0"}</h2>
              <h5>Approval</h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 2
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 2,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >

              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99996 18.3332C14.6023 18.3332 18.3333 14.6022 18.3333 9.99984C18.3333 5.39746 14.6023 1.6665 9.99996 1.6665C5.39759 1.6665 1.66663 5.39746 1.66663 9.99984C1.66663 14.6022 5.39759 18.3332 9.99996 18.3332Z" stroke="#272D3B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.05835 8.9502L10 11.8835L12.9417 8.9502" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <h2>{this.state.statusCount.active ? this.state.statusCount.active : "0"}</h2>
              <h5>Active</h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 3
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 3,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >

              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 7.5V11.6667" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.99998 17.8419H4.94998C2.05832 17.8419 0.849985 15.7752 2.24998 13.2502L4.84998 8.56689L7.29998 4.16689C8.78332 1.49189 11.2167 1.49189 12.7 4.16689L15.15 8.57523L17.75 13.2586C19.15 15.7836 17.9333 17.8502 15.05 17.8502H9.99998V17.8419Z" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.99536 14.1665H10.0028" stroke="#272D3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <h2>{this.state.statusCount.expired ? this.state.statusCount.expired : "0"}</h2>
              <h5>Expired</h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 4
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 4,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >

              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 18.3332C14.5834 18.3332 18.3334 14.5832 18.3334 9.99984C18.3334 5.4165 14.5834 1.6665 10 1.6665C5.41669 1.6665 1.66669 5.4165 1.66669 9.99984C1.66669 14.5832 5.41669 18.3332 10 18.3332Z" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.64166 12.3583L12.3583 7.6416" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.3583 12.3583L7.64166 7.6416" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>


              <h2>{this.state.statusCount.terminated ? this.state.statusCount.terminated : "0"}</h2>
              <h5>Terminated</h5>
            </div>
            <div
              className={
                this.state.selectedStatus === 8
                  ? "cardsNewUiInner isActive"
                  : "cardsNewUiInner"
              }
              onClick={(e) => {
                //this.setState({ selectedAsset: e.target.value });
                this.setState({
                  selectedStatus: 8,
                  randomNum: Math.random(),
                  showProspect: false,
                });
              }}
            >

              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.16669 18.3332V9.07391M4.16669 9.07391V2.15575C4.16669 1.88555 4.39199 1.6665 4.66991 1.6665H7.18723C8.91201 1.6665 10.5661 2.33263 11.7857 3.51836C13.0053 4.70408 14.6595 5.37021 16.3842 5.37021H17.1645C17.3498 5.37021 17.5 5.51624 17.5 5.69637V12.2283C17.5 12.5317 17.247 12.7776 16.935 12.7776H14.4795C12.7547 12.7776 11.1006 12.1115 9.88097 10.9258C8.66137 9.74004 7.00724 9.07391 5.28247 9.07391H4.16669Z" stroke="#272D3B" stroke-width="1.5" stroke-linecap="round" />
              </svg>

              <h2>{this.state.statusCount.fnf ? this.state.statusCount.fnf : "0"}</h2>
              <h5>F&F</h5>
            </div>
          </div>
        </div>
        {/* <LeaseListingTable
          key={this.state.randomNum}
          asset={this.state.selectedAsset}
          brand={this.state.selectedBrand}
          status={this.state.selectedStatus}
          stateId={this.state.state}
        /> */}

        {this.state.showProspect ? (
          <ProspectListingTable
            key={this.state.randomNum}
            isDropped={this.state.isDropped}
            asset={this.state.selectedAsset}
            brand={this.state.selectedBrand}
            status={this.state.selectedStatus}
          />
        ) : (
          <LeaseListingTable
            key={this.state.randomNum}
            asset={this.state.selectedAsset}
            brand={this.state.selectedBrand}
            status={this.state.selectedStatus}
            stateId={this.props.match.params.state}
          />
        )}
      </>
    );
  }
}

export default withRouter(LeaseListing);
